var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarIcon = function SvgStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.963 6.786a.75.75 0 0 0-.605-.51l-4.62-.671-2.066-4.187c-.252-.512-1.093-.512-1.345 0L6.261 5.604l-4.62.671a.75.75 0 0 0-.415 1.279l3.343 3.258-.79 4.601a.75.75 0 0 0 1.088.791L9 14.031l4.132 2.173a.75.75 0 0 0 .79-.057.75.75 0 0 0 .298-.734l-.79-4.601 3.343-3.258a.75.75 0 0 0 .19-.769z"
  })));
};
export default SvgStarIcon;